/** Companies page copy. EN mirrors SV until translated. */
export const pagesCompaniesSv = {
    filters: {
        showAllCompanies: 'Visa alla bolag',
        onlyListedCompanies: 'Visa enbart noterade bolag',
        onlyDelistedCompanies: 'Visa enbart avnoterade bolag',
        delistedLabel: 'Avnoterade',
        marketCap: 'Börsvärde',
    },
    delistedSince: '(Avnoterad sedan {{date}})',
    upcomingIpo: 'Planerad notering {{date}}',
    cancelledIpo: 'Avbruten IPO',
    orgNumber: 'Orgnr',
    totalShares: 'Totalt antal aktier',
    marketCap: 'Börsvärde',
    tooltips: {
        totalShares:
            'Det totala antalet aktier för samtliga aktieslag plus maximal utspädning från hypotetiskt fulltecknade emissioner.',
        marketCap:
            'Börsvärde baseras på totalt antal aktier plus maximal utspädning från hypotetiskt fulltecknade emissioner.',
        registeredShares:
            'Antal registrerade aktier per aktieslag. Definitionen kan variera för exempelvis dubbelnoterade aktier. Källa: Millistream',
    },
    shareN: 'Aktie {{n}}',
    numberOfShares: 'Antal aktier',
    delisted: 'Avnoterad',
    shareDelistedSince: 'Aktien är avnoterad sedan {{date}}',
    pressReleases: 'Pressmeddelanden',
    pressRelease: {
        error: 'Någonting gick fel, pressmeddelandena kunde inte hämtas.',
        listView: 'Listvy',
        linkMode: 'Koppla',
        linkedFiles: 'Länkade filer',
        relatedTransactions: 'Relaterade transaktioner',
    },
    vwap: {
        days: 'Dagar',
        vwapDays: 'VWAP {{n}} dagar',
        turnoverPerDay: 'Omsättning / dag',
    },
    currentTransactions: {
        empty: 'Inga pågående eller kommande emissioner, teckningsoptioner eller konvertibellån.',
        title: 'Aktuella emissioner, TO och konvertibellån',
        subscriptionPrice: 'Teckningskurs',
    },
    guarantorIssue: 'Garantieemission',
    abbDirectedIssue: 'Accelererad bookbuilding',
    convertibleLoans: 'Konvertibellån',
    loan: 'Lån',
    terms: 'Villkor',
    outstandingLoanAmount: 'Utestående lånebelopp i {{currency}}',
    noConvertiblesFound: 'Inga konvertibler hittades',
    history: {
        title: 'Historik',
        adjustForSplits: 'Justera för aktiesplittar',
        event: 'Händelse',
        subscribedShares: 'Antal tecknade aktier',
        amountInCurrency: 'Belopp i {{currency}}',
        bonusIssue: 'Fondemission {{new}}:{{old}}',
        stockSplit: 'Aktiesplit {{new}}:{{old}}',
        nameChange: 'Namnändring från {{from}} till {{to}}',
        zeroNewShares: '0 nya aktier',
        overAllotment: 'Övertilldelning',
        existingShares: 'Befintliga aktier',
        overAllotmentExisting: 'Övertilldelning befintliga',
        directedIssueToGuarantors: 'Riktad emission till garanter',
        delistingOf: 'Avnotering av {{name}}',
        listingOf: 'Notering av {{name}}',
        stockSplitLabel: 'Aktiesplit',
        bonusIssueLabel: 'Fondemission',
    },
    changeDate: 'Ändringsdatum',
    share: 'Aktie',
    btaBtu: 'BTA/BTU',
    rights: 'Rätter',
    volume: 'Volym',
    graph: {
        closePrice: 'Stängningskurs',
        vwap: 'VWAP',
        turnoverSek: 'Omsättning i SEK',
        tradedProportion: 'Omsatta aktier / Totalt antal',
        timeRange: {
            oneMonth: '1 m',
            threeMonths: '3 m',
            yearToDate: 'i år',
            oneYear: '1 år',
            threeYears: '3 år',
            max: 'max',
        },
        timeIntervalAria: 'Tidsintervall',
        settings: 'Inställningar',
        selectSeries: 'Välj serie',
        selectBars: 'Välj staplar',
        smoothLine: 'Mjuk linjegraf',
        clickEventHint: 'Klicka på en händelse i grafen för att visa information.',
        tooltip: {
            mcap: 'Mcap',
            close: 'Close',
            change: 'Utv',
            turnover: 'Oms',
            shares: 'Aktier',
        },
    },
    tabs: {
        aboutShare: 'Om aktien',
        aboutCompany: 'Om bolaget',
        selectedEvent: 'Vald händelse',
    },
}
